module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "sigil_toc_id_4",
      "title": "Dedication"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("In honor of Richard L. Twiss")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("June 11, 1954–February 9, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "ifirstcenter"
  }, [_vm._v("A follower of the Jesus Way"), _c('br'), _vm._v("\n  and a real human being")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('img', {
    staticClass: "shrule",
    attrs: {
      "alt": "",
      "src": "Images/ded.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 63
// module chunks = 0